import React from 'react';

function DiversionText() {
  return (
    <p>
    The diversion of weapons from national stockpiles and the illicit international transfer of small arms to unauthorized recipients is the primary sources for the illicit market. States recognized the need for continued dialogue, information exchange and concerted action at the national, regional and international levels on the implementation of measures to prevent them. States resolved, therefore, to undertake relevant measures such as assessment of diversion risks and identification of diversion points.

    </p>
  );
}

export default DiversionText;



// WEBPACK FOOTER //
// ./src/components/Diversion/DiversionText.js